// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateChangesResult from './labor-rate-changes-result';
import LaborRateChangesSortOptions from '../../services/labor-rate-changes-sort-options';
import {Link} from 'react-router';
import RefinableListWidget from '../../../../shared/components/refinable-list-widget';
import SearchFilters from '../../../../shared/state/search-filters';

const LaborRateChangesList = props =>
    <div>
        <RefinableListWidget
            onFilterByChange={props.updateListFilterBy}
            onSortByChange={props.updateListSortBy}
            onSortDirectionChange={props.updateListSortDirection}
            searchFilters={props.laborRateChangesSearchFilters}
            sortOptions={LaborRateChangesSortOptions}
        />
        {props.laborRateChanges.map(requestAccount =>
            <section
                className='account-group'
                key={requestAccount.requestId}
            >
                <header>
                    <Link
                        to={`/tcsm/wip/labor-rates/${requestAccount.requestId}`}
                    >
                        {requestAccount.requestId}
                    </Link>
                </header>
                <section>
                    <LaborRateChangesResult
                        key={requestAccount.account}
                        laborRateChange={requestAccount}
                    />
                </section>
            </section>
        )}
    </div>;

LaborRateChangesList.displayName = 'LaborRateChangesList';
LaborRateChangesList.propTypes = {
    laborRateChanges: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    laborRateChangesSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    updateListFilterBy: PropTypes.func.isRequired,
    updateListSortBy: PropTypes.func.isRequired,
    updateListSortDirection: PropTypes.func.isRequired
};

export default LaborRateChangesList;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/labor-rate-changes/labor-rate-changes-list.js